import { Injectable } from '@angular/core';
import { HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'


import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class PostService {
    constructor( private clientRequest: ClientRequest) {};
    
    findPost(id): Observable<any> {
        return this.clientRequest.get('/post/' + id).map((response: HttpResponse<any>) => {
                return response;
            });
    };
     getPosts(page): Observable<any> {
     	page = page ?  page: 0 ; 
        return this.clientRequest.get('/posts?page=' + page).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    getPostsHome(page): Observable<any> {
        page = page ?  page: 0 ; 
        return this.clientRequest.get('/home/posts?page=' + page).map((response: HttpResponse<any>) => {
                return response;
        });
    };
    findCategory(category_id, post_id=0): Observable<any> {
        return this.clientRequest.get('/categories/' + category_id+'?postId='+post_id).map((response: HttpResponse<any>) => {
            return response;
        });
    };
}